var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSolServiceDeskTicketing01 = function SvgSolServiceDeskTicketing01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "sol_service_desk_ticketing-01_svg2__a",
    x1: 40.18,
    x2: 207.9,
    y1: 208.67,
    y2: 38.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3D43C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#5934b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#7523a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#89179f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#9b0d98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_service_desk_ticketing-01_svg2__a",
    id: "sol_service_desk_ticketing-01_svg2__b",
    x1: 13.67,
    x2: 181.39,
    y1: 182.52,
    y2: 12.54
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_service_desk_ticketing-01_svg2__a",
    id: "sol_service_desk_ticketing-01_svg2__c",
    x1: 31.1,
    x2: 198.82,
    y1: 199.72,
    y2: 29.74
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_service_desk_ticketing-01_svg2__a",
    id: "sol_service_desk_ticketing-01_svg2__d",
    x1: 33.52,
    x2: 201.24,
    y1: 202.11,
    y2: 32.13
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_service_desk_ticketing-01_svg2__a",
    id: "sol_service_desk_ticketing-01_svg2__e",
    x1: -28.75,
    x2: 138.97,
    y1: 140.66,
    y2: -29.31
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_service_desk_ticketing-01_svg2__a",
    id: "sol_service_desk_ticketing-01_svg2__f",
    x1: -39.14,
    x2: 128.58,
    y1: 130.41,
    y2: -39.57
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_service_desk_ticketing-01_svg2__a",
    id: "sol_service_desk_ticketing-01_svg2__g",
    x1: -33.23,
    x2: 134.48,
    y1: 136.24,
    y2: -33.74
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#sol_service_desk_ticketing-01_svg2__a",
    id: "sol_service_desk_ticketing-01_svg2__h",
    x1: -31.93,
    x2: 135.79,
    y1: 137.52,
    y2: -32.45
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M176.96 111.59h-1.7l-11.51-3.44v-2.77c12.2-5.51 21.51-17.2 24.39-31.87 4.82-1.6 8.25-6.37 8.25-11.87 0-3.54-1.41-6.74-3.66-9.01V30.18c0-7.16-5.82-12.99-12.98-12.99h-.97v-1.97c0-8.03-9.03-13.22-23-13.22-12.01 0-24.93 3.77-34.54 10.08-12.18 7.99-18.61 19.34-18.61 32.84v8.1c-2.04 2.24-3.3 5.28-3.3 8.62 0 5.5 3.43 10.27 8.25 11.87 1.89 9.53 6.64 18.2 13.51 24.58 3.28 3.04 6.95 5.48 10.88 7.26v2.8l-11.52 3.44h-3.4v-6.97c0-4.41-3.59-8.01-8.01-8.01H16.3c-4.41 0-8.01 3.59-8.01 8.01v63.03c0 4.41 3.59 8.01 8.01 8.01h29.54l-1.3 7.39h-24.9a2.73 2.73 0 0 0-2.73 2.74v11.44c0 1.51 1.22 2.74 2.73 2.74h157.31c12.71 0 23.04-10.34 23.04-23.04v-42.28c0-12.71-10.34-23.04-23.04-23.04Zm-6.28 4.34-11 18.2-8.03-5.48 1.27-1.85 9.21-13.42 8.55 2.56Zm-17.4 20.46v4.07h-10.86v-4.07l5.43-3.71 5.44 3.71Zm-15.85-27.06v-1.98c3.38.96 6.88 1.46 10.42 1.46s7.09-.5 10.43-1.44v1.97l-10.43 15.19-10.42-15.19Zm-29.35-64.41c0-14.61 8.78-23.43 16.14-28.26 8.76-5.75 20.55-9.18 31.54-9.18 10.32 0 17.53 3.19 17.53 7.75v4.71a2.73 2.73 0 0 0 2.74 2.73h3.71c4.14 0 7.51 3.37 7.51 7.52v19.34a11.263 11.263 0 0 0-6.08.21l-2.62-10.6a12.29 12.29 0 0 0-13.76-9.24l-18.67 2.74-16.83.48c-8.8.26-15.69 7.35-15.69 16.15v.22a11.18 11.18 0 0 0-5.53.14v-4.69Zm4.57 25.91a2.74 2.74 0 0 0-2.33-2.28c-3.15-.43-5.53-3.4-5.53-6.91 0-3.85 2.84-6.98 6.32-6.98 1.29 0 2.53.43 3.59 1.23.83.63 1.94.74 2.87.27.93-.46 1.52-1.41 1.52-2.45v-4.46c0-5.82 4.56-10.52 10.38-10.69l16.99-.49c.11 0 .21-.01.32-.03l18.82-2.77c3.51-.52 6.8 1.7 7.66 5.15l3.44 13.94c.22.89.88 1.62 1.75 1.92.87.31 1.83.16 2.57-.4 1.06-.81 2.3-1.23 3.59-1.23 3.49 0 6.32 3.13 6.32 6.98 0 3.51-2.38 6.48-5.53 6.91-1.2.16-2.14 1.09-2.33 2.28-2.97 18.83-17.78 32.5-35.21 32.5-17.42 0-32.23-13.67-35.2-32.5Zm20.91 42.54 10.48 15.27-8.02 5.48-11.01-18.2 8.55-2.56ZM16.3 170.19c-1.4 0-2.54-1.14-2.54-2.54v-63.03c0-1.4 1.14-2.54 2.54-2.54h92.74c1.4 0 2.54 1.14 2.54 2.54v63.03c0 1.4-1.14 2.54-2.54 2.54H78.53l-2.52-14.3a2.734 2.734 0 0 0-2.69-2.26H52.03c-1.33 0-2.46.95-2.69 2.26l-2.52 14.3H16.31Zm76.84 5.47v7.39H80.8l-1.3-7.39zm-17.9 7.38H50.1l4.22-23.95h16.7zm27.72 11.44H22.38v-5.97h80.58zm11.23 0h-5.76v-8.7c0-1.51-1.22-2.74-2.73-2.74h-7.09v-7.39h10.43c4.41 0 8.01-3.59 8.01-8.01v-50.59h2.26l13.54 22.38c.39.64 1.03 1.1 1.76 1.26.19.04.39.06.58.06.55 0 1.08-.16 1.54-.48l.23-.16v2.15c0 1.61 1.05 2.98 2.5 3.47l-4.4 28.28h-10.29c-7.15 0-12.97 5.82-12.97 12.97 0 2.79.89 5.38 2.4 7.5Zm26.18 0h-15.61c-4.13 0-7.5-3.36-7.5-7.5s3.36-7.5 7.5-7.5h15.61v14.99Zm.22-20.46 4.37-28.09h5.77l4.37 28.09h-14.52Zm53.94 2.89c0 9.69-7.88 17.57-17.57 17.57h-31.12v-14.99h30.96c1.51 0 2.74-1.22 2.74-2.74v-31.07c0-1.51-1.22-2.74-2.74-2.74s-2.73 1.22-2.73 2.74v28.34h-13.43l-4.4-28.28a3.66 3.66 0 0 0 2.52-3.47v-2.15l.23.16c.46.31 1 .48 1.54.48a2.73 2.73 0 0 0 2.34-1.32l13.53-22.38h.56c9.69 0 17.57 7.88 17.57 17.57z",
    style: {
      fill: "url(#sol_service_desk_ticketing-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.02 61.06c-1.51 0-2.74 1.22-2.74 2.73v3.64c0 1.51 1.22 2.74 2.74 2.74s2.73-1.22 2.73-2.74v-3.64c0-1.51-1.22-2.73-2.73-2.73",
    style: {
      fill: "url(#sol_service_desk_ticketing-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.41 70.18c1.51 0 2.74-1.22 2.74-2.73v-3.64c0-1.51-1.22-2.74-2.74-2.74s-2.74 1.22-2.74 2.74v3.64a2.73 2.73 0 0 0 2.74 2.73",
    style: {
      fill: "url(#sol_service_desk_ticketing-01_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.68 86.72a2.74 2.74 0 0 0-1.65-3.5 2.74 2.74 0 0 0-3.5 1.65c-1.04 2.9-3.81 4.86-6.89 4.86s-5.85-1.95-6.89-4.86a2.74 2.74 0 0 0-3.5-1.65 2.74 2.74 0 0 0-1.65 3.5c1.82 5.07 6.66 8.48 12.04 8.48s10.22-3.41 12.04-8.48",
    style: {
      fill: "url(#sol_service_desk_ticketing-01_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.06 89.95c1.51 0 2.74-1.22 2.74-2.74v-16c0-1.51-1.22-2.74-2.74-2.74-2.75 0-4.98-2.24-4.98-4.99s2.24-4.98 4.98-4.98c1.51 0 2.74-1.22 2.74-2.74v-16c0-1.51-1.22-2.74-2.74-2.74h-2.33l-5.46-9.44a2.734 2.734 0 0 0-3.73-1c-1.08.62-2.34.78-3.56.46a4.66 4.66 0 0 1-2.84-2.18 4.704 4.704 0 0 1 1.72-6.41c1.3-.76 1.75-2.43 1-3.73L69.18 1.41a2.734 2.734 0 0 0-3.74-1L47.56 10.73l-.06.03c-.02.01-.03.02-.05.03L1.37 37.4C.55 37.87 0 38.76 0 39.77v16c0 1.51 1.22 2.74 2.74 2.74h.78c2.75 0 4.98 2.24 4.98 4.98s-2.24 4.99-4.98 4.99h-.78C1.23 68.48 0 69.7 0 71.21v16a2.73 2.73 0 0 0 2.74 2.73h89.33ZM65.79 6.52l5.14 8.9c-3.1 3.18-3.86 8.16-1.54 12.18 1.35 2.34 3.54 4.02 6.16 4.73 1.72.46 3.49.47 5.16.04l2.69 4.66H65.79L52.58 14.14l13.2-7.62ZM47.85 16.88l11.63 20.16H12.94zm19.92 67.6H5.47V73.76c4.83-.92 8.49-5.18 8.49-10.28s-3.66-9.35-8.49-10.27V42.5h62.29v41.98Zm21.56 0H73.24V42.5h16.09v10.89c-4.44 1.21-7.72 5.27-7.72 10.09s3.28 8.89 7.72 10.1v10.89Z",
    style: {
      fill: "url(#sol_service_desk_ticketing-01_svg2__e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.75 48.94h-36.4c-1.51 0-2.74 1.22-2.74 2.74s1.22 2.74 2.74 2.74h36.4c1.51 0 2.74-1.22 2.74-2.74s-1.22-2.74-2.74-2.74",
    style: {
      fill: "url(#sol_service_desk_ticketing-01_svg2__f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.75 60.75h-36.4c-1.51 0-2.74 1.22-2.74 2.74s1.22 2.74 2.74 2.74h36.4c1.51 0 2.74-1.22 2.74-2.74s-1.22-2.74-2.74-2.74",
    style: {
      fill: "url(#sol_service_desk_ticketing-01_svg2__g)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.56 72.58h-18.2c-1.51 0-2.74 1.22-2.74 2.74s1.22 2.74 2.74 2.74h18.2c1.51 0 2.73-1.22 2.73-2.74s-1.22-2.74-2.73-2.74",
    style: {
      fill: "url(#sol_service_desk_ticketing-01_svg2__h)"
    }
  }));
};
export default SvgSolServiceDeskTicketing01;